import { useContext, createContext } from 'react';

import type { SearchContextType, SearchProviderType } from './types';

const INITIAL_CONTEXT_STATE: SearchContextType = {
  count: 0,
  filters: {},
  listLength: 0,
  loading: true,
  loadMore: () => undefined,
  results: [],
  searchPageSize: 0,
  searchParams: {},
  setSearchParams: () => undefined,
  resetFilters: () => undefined,
  viewerId: '',
};

const SearchContext = createContext<SearchContextType>(INITIAL_CONTEXT_STATE);

export const useSearchContext = (): SearchContextType => {
  const context = useContext(SearchContext);

  return context;
};

export const SearchProvider: React.FC<SearchProviderType> = ({
  children,
  context,
}) => {
  return (
    <SearchContext.Provider value={context}>{children}</SearchContext.Provider>
  );
};
